<template>
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-2 .9-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a1.9999 1.9999 0 00-2-2zM7 11V9h2v2H7zm2 4v-2H7v2h2zm0 4v-2H7v2h2zm4-2h-2v2h2v-2zm2 2v-2h2v2h-2zm-4-6h2v2h-2v-2zm6 2v-2h-2v2h2zm-4-6h-2v2h2V9zm2 2V9h2v2h-2z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: "CalendarIcon"
};
</script>
